import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { Form, Select, Avatar, Button } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import imageReservando from './../../images/ic_launcher.png';

const { Option } = Select;

const PromotionsAdminComponent = ({ onExit, onSubmit, categoriesOfPromotions, onCategorySelected, typesOfCategory, onTypeSelected, isSavedPromotions, fileTypePromotion, isLoadingIcon }) => {

    const [form] = Form.useForm();

    const onReset = () => {
        form.resetFields();
    }

    return (
        <Grid>
            <Form onFinish={onSubmit} form={form}>
                <Row styles={{ float: 'left' }}>
                    <Col xs={6}>
                        <Button onClick={onExit}>
                            Volver
                        </Button>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={10} sm={8} md={4}>
                        {
                            isLoadingIcon ?
                                <Avatar size={64} > <LoadingOutlined /> </Avatar>
                                :
                                <Avatar size={64} src={fileTypePromotion.length > 0 ? fileTypePromotion[0].url : imageReservando} />
                        }
                    </Col>
                </Row>
                <br />
                <Row center="xs">
                    <Col xs={10} sm={8} md={4}>
                        <Form.Item name="field_none_category" rules={[{ required: false, message: 'Por favor, seleccione una categoría' }]}>
                            <Select placeholder="Categoría" onSelect={onCategorySelected}>
                                {
                                    categoriesOfPromotions && categoriesOfPromotions.map(category => <Option key={category} value={category}>{category}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={10} sm={8} md={4}>
                        <Form.Item name="field_none_type" rules={[{ required: false, message: 'Por favor, seleccione un tipo' }]}>
                            <Select placeholder="Tipo" onSelect={onTypeSelected}>
                                {
                                    typesOfCategory && Object.keys(typesOfCategory).map(key => <Option key={key} value={key}>{typesOfCategory[key].text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                {
                    isSavedPromotions && onReset()
                }
            </Form>
        </Grid>
    );
};

PromotionsAdminComponent.propTypes = {
    categoriesOfPromotions: PropTypes.array,
};

export default PromotionsAdminComponent;